exports.version = "2.3.7"


// WEBPACK FOOTER //
// ./node_modules/apollo-client/version.js